export const getTeamExternalId = (matchDetails, side) => {
    if (process.env.REACT_APP_LEAGUE_NAME === 'nhl') {
        return matchDetails[side + 'TeamShortName'];
    } else {
        return matchDetails[side + 'TeamFeedId'];
    }
}